// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box" ng-form="\$ctrl.form">
  <div>
      <h2 class="section-header">Depository account selection</h2>
      <table class="table">
      <tbody>
      <tr>
        <td>1.</td>
        <td>Branch</td>
        <td>
          {{\$ctrl.branch.name}}
        </td>
      </tr>
      <tr>
        <td>2.</td>
        <td>Depository account</td>
        <td>
          <select ng-model="\$ctrl.checkbookSummary"
                  ng-options="checkbook.accountName for checkbook in \$ctrl.checkbookOptions"
                  ng-required="true">
          </select>
        </td>
      </tr>
      <tr>
        <td>3.</td>
        <td>Check date</td>
        <td>
          <date ng-required="true"
                ng-model="\$ctrl.checkDate"></date>
        </td>
      </tr>
      <tr>
        <td>4.</td>
        <td>Check # start</td>
        <td>
          {{\$ctrl.checkbookSummary.firstAvailableCheckNumber}}
        </td>
      </tr>
      <tr>
        <td>5.</td>
        <td>Used</td>
        <td>
          {{\$ctrl.checkbookSummary.usedChecks}}
        </td>
      </tr>
      <tr>
        <td>6.</td>
        <td>Unused</td>
        <td>
          {{\$ctrl.checkbookSummary.unusedChecks}}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div>
    <h2 class="section-header">Check assignment</h2>
    <div class="alert-container">
      <div class="alert alert--danger" ng-if="\$ctrl.assignedLoans > \$ctrl.checkbookSummary.unusedChecks">
        <span>The number of selected loans for check assignment exceeds the number of checks available for this account</span>
      </div>
    </div>
    <table class="table" ng-table="\$ctrl.tableConfig">
      <thead>
      <tr>
        <th>No</th>
        <th>CIF number</th>
        <th>Name</th>
        <th>Product</th>
        <th>Net proceeds</th>
        <th>
          Assign check?
          <input type="checkbox"
                 ng-model="\$ctrl.shouldAssignCheck"
                 ng-change="\$ctrl.toggleAssignChecks()"/>
        </th>
      </tr>
      </thead>
      <tr ng-repeat="loan in \$data">
        <td>{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
        <td>{{loan.customerNumber}}</td>
        <td>{{loan.customerName}}</td>
        <td>{{loan.productName}}</td>
        <td>{{loan.releaseAmount | nxCurrency}}</td>
        <td>
          <input type="checkbox"
                 ng-model="loan.shouldAssignCheck"
                 ng-checked="loan.shouldAssignCheck"
                 ng-change="\$ctrl.updateAssignedLoanCount()"/>
        </td>
      </tr>
    </table>
    <div class="buttons">
      <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Cancel</button>
      <button class="btn btn-success"
              ng-click="\$ctrl.assignChecks()"
              ng-disabled="!\$ctrl.canAssignChecks() || \$ctrl.form.\$invalid">
        Assign Check
      </button>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/check-preparation/assignment/check-assignment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;